import { render, staticRenderFns } from "./ManagerDetail.vue?vue&type=template&id=ccd78df0&"
import script from "./ManagerDetail.vue?vue&type=script&lang=js&"
export * from "./ManagerDetail.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports